import Cookies from "@components/Cookies";
import DownloadApp from "@components/DownloadApp";
import Toaster from "@components/Toaster";
import { PreferencesProvider } from "@contexts/Preferences";
import { Navigate, useRoutes } from "@solidjs/router";
import { type VoidComponent, lazy } from "solid-js";
import { AppWrapper } from "./styled";

const Outlet = useRoutes([
	{ path: "/getapp", component: lazy(() => import("@layouts/GetApp")) },
	{ path: "/embed/tracklist/:uuid/*index", component: lazy(() => import("@layouts/Embed")) },
	{ path: "/auth/*", component: lazy(() => import("@layouts/Auth")) },
	{ path: "/public/*", component: lazy(() => import("@layouts/Public")) },
	{ path: "/docs/*", component: lazy(() => import("@layouts/Docs")) },
	{ path: "/landing/*", component: lazy(() => import("@layouts/Landing")) },
	{ path: "/", component: () => <Navigate href="/landing/*" /> },
	{ path: "/*", component: lazy(() => import("@layouts/App")) },
]);

const App: VoidComponent = () => {
	return (
		<PreferencesProvider>
			<AppWrapper>
				<Outlet />
				<DownloadApp />
				<Cookies />
				<Toaster />
			</AppWrapper>
		</PreferencesProvider>
	);
};
export default App;
